import {
  GET_REPORT_DATA_TEMPLATES_REQUEST,
  GET_REPORT_DATA_TEMPLATES_SUCCESS,
  GET_REPORT_DATA_TEMPLATES_ERROR,
} from '../../actions'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../constants/fetchStates'

const initial = {
  data: [],
  status: IDLE
}

const reportDataTemplates = (state = initial, action) => {
  switch (action.type) {
    case GET_REPORT_DATA_TEMPLATES_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case GET_REPORT_DATA_TEMPLATES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FETCHED
      }

    case GET_REPORT_DATA_TEMPLATES_ERROR:
      return {
        ...state,
        status: FAILED
      }

    default:
      return state
  }
}

export default reportDataTemplates
